/* eslint-disable prefer-template */
import React, { useEffect, useState } from 'react';
import '../style.css';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, TextField } from '@material-ui/core';
import RegistrationStatus from './registrationStatus';

export default function WithRegistration({
	handleChange,
	hanleContinue,
	errorObj,
	webinarData,
	registrationStatus
})
{
	const intl = useIntl();

	const [ localErrorObj, setLocalErrorObj ] = useState({});
	const [ isButtonDisabled, setIsButtonDisabled ] = useState(false);
	const [ isEnded, setIsEnded ] = useState(false);

	const validateEmailDomain = (email) =>
	{
		// If no email, return early
		if (!email) return true;

		// Extract domain from email
		const domain = email.split('@')[1];

		// Check authorized domains
		if (webinarData?.authorizedDomains?.length > 0)
		{
			const isAuthorizedDomain = webinarData.authorizedDomains.some(
				(authDomain) => domain === authDomain
			);

			if (!isAuthorizedDomain)
			{
				setLocalErrorObj((prev) => ({
					...prev,
					emailDomainErr : intl.formatMessage(
						{ id: 'email.unauthorized_domain', defaultMessage: 'This email domain is not authorized.' }
					)
				}));
				setIsButtonDisabled(true);

				return false;
			}
		}

		// Check restricted domains
		if (webinarData?.restrictedDomains?.length > 0)
		{
			const isRestrictedDomain = webinarData.restrictedDomains.some(
				(restrictedDomain) => domain === restrictedDomain
			);

			if (isRestrictedDomain)
			{
				setLocalErrorObj((prev) => ({
					...prev,
					emailDomainErr : intl.formatMessage(
						{ id: 'email.restricted_domain', defaultMessage: 'This email domain is not allowed.' }
					)
				}));
				setIsButtonDisabled(true);

				return false;
			}
		}

		// Clear domain-related errors if validation passes
		const { emailDomainErr, ...restErrors } = localErrorObj;

		setLocalErrorObj(restErrors);
		setIsButtonDisabled(false);

		return true;
	};

	const modifiedHandleChange = (e) =>
	{
		// Call the original handleChange first
		handleChange(e);

		// If the field is email, perform domain validation
		// if (e.target.id === 'Email')
		// {
		// 	validateEmailDomain(e.target.value);
		// }
	};

	useEffect(() =>
	{
		// Function to check if the meeting has ended
		const checkMeetingStatus = () =>
		{
			const currentTimeUTC = new Date(); // Current time in UTC format

			const EndTimeUtc = new Date(webinarData.endTimeUTC);

			const diffTime = currentTimeUTC - EndTimeUtc;

			console.log('fffffffffffffff', currentTimeUTC, EndTimeUtc);

			if (diffTime > 0)
			{
				setIsEnded(true);
			}
		};

		// Initial check
		checkMeetingStatus();

		// Optional: Set an interval to check periodically
		const interval = setInterval(checkMeetingStatus, 1000);

		// Cleanup the interval on component unmount
		return () => clearInterval(interval);
	}, [ webinarData.endTimeUTC ]);

	return (
		<>
			{registrationStatus || registrationStatus === 'approved' || registrationStatus==='pending' || isEnded ?
				<RegistrationStatus isEnded={isEnded} status={registrationStatus} />
				:
				<div className='flexCol'>
					<span className='mHdng'>Register for the event</span>
					<span className='small'>Fill the form below to register for this event you will recieve a confirmation by email</span>
					<div className='flexCol pdngVSM fieldCntnr'>
						{
							webinarData?.registrationFields?.map((each, index) => (
								<div className='flexCol pdngVSM' key={index}>
									<TextField
										fullWidth
										id={each?.field}
										label={each?.field}
										variant='standard'
										size='small'
										required={each?.required}
										// type={each?.inputType === 'numeric'? 'number':'text'}
										// onKeyDown={(evt) => each?.inputType === 'numeric' && evt.key === 'e' && evt.preventDefault()}
										className='streamFields'
										onChange={modifiedHandleChange}
									// value={userDetails.each?.field}
									/>
									{
										Object.keys(localErrorObj).length > 0 && each?.field === 'Email' &&
										<small className='small pdngTXXS errTxt'>{localErrorObj.emailDomainErr}</small>
									}
									{
										Object.keys(errorObj).length > 0
										&&
										<small className='small pdngTXXS errTxt'>{errorObj[each?.field + '_err']}</small>
									}
								</div>
							))
						}
					</div>
					<div className='flexCol jCntr pdngVMD w50'>
						<Button
							onClick={hanleContinue}
							variant='contained'
							color='primary'
							id='joinButton'
							// disabled={displayName === '' || joining}
							// fullWidth
							disableElevation
							// disabled={isButtonDisabled}
						>
							<FormattedMessage
								id='webinar.continue'
								defaultMessage='Continue'
							/>
						</Button>
					</div>
				</div>
			}
		</>
	);
}
